import React, { useEffect, useState } from 'react';
import { crmRequest } from './crmApi';
import CompanyProductFields from './CompanyProductFields';

export default function CompanyProductEditor({ company, categories, onSaved, disabled = false }) {
    const [draft, setDraft] = useState({ category: company.category || [], product: company.product || [] });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        setDraft({ category: company.category || [], product: company.product || [] });
        setError('');
    }, [company._id, company.category, company.product, company.revision]);
    const changed = JSON.stringify(draft.category) !== JSON.stringify(company.category || []) || JSON.stringify(draft.product) !== JSON.stringify(company.product || []);
    async function save() {
        if (!changed || saving || disabled) return;
        setSaving(true); setError('');
        try { onSaved(await crmRequest(`/companies/${company._id}/product`, 'patch', { ...draft, revision: company.revision || 0 })); }
        catch (error) { setError(error.message); }
        finally { setSaving(false); }
    }
    return <div>
        <CompanyProductFields draft={draft} onChange={setDraft} categories={categories} disabled={disabled || saving} />
        {changed && <button type="button" disabled={disabled || saving} onClick={save}>{saving ? 'Guardando…' : 'Guardar categoría y producto'}</button>}
        {saving && <small role="status">Guardando…</small>}
        {error && <small role="alert" className="crm-error">{error}</small>}
    </div>;
}
